import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { StandardControlPSALoader } from '../helpers/ai/standardControlPSA/StandardControlPSALoader';
import { StandardControlPSAViewer } from '../helpers/ai/standardControlPSA/StandardControlPSAViewer';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const StandardControlPSA = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.STANDARD_CONTROL_PSA.lightIcon : AI_UTILITIES.STANDARD_CONTROL_PSA.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.STANDARD_CONTROL_PSA.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.STANDARD_CONTROL_PSA.name}</h4>
            </div>
            <Switch>
                <Route exact path={AI_UTILITIES.STANDARD_CONTROL_PSA.path} component={StandardControlPSALoader} />
                <Route path={`${AI_UTILITIES.STANDARD_CONTROL_PSA.path}/:inputIdentifier`} component={StandardControlPSAViewer} />
            </Switch>
        </div>
    );
};

StandardControlPSA.displayName = 'StandardControlPSA';